export default "__VITE_ASSET__Da$94A8A__"